import {store} from './../../redux/';
import { call, put } from 'redux-saga/effects';
import { url } from './../../services/Url';
import CONSTANTS from '../../util/constants';
import APICallingService from '../../services/APICallingService';
import { Alert } from 'bootstrap';


const getTrailerAPI = () => {
    return APICallingService.sendRequestForGet(url.getTrailers, (res) => {
    }, true);
}

function* getTrailerManagement() {
    try {
        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });
        const response = yield call(getTrailerAPI);
        if (response && response != null && response?.callBackStatus?.toLowerCase() == 'success') {
            let statusActiveTrailerData = response?.data.filter((item) => {
                return item.status == 'ACTIVE'
            })
            yield put({ type: CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT.GET_TRAILER_API_SUCCESS, payload: { value: statusActiveTrailerData } });
        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to get trailers data');
                yield put({ type: CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT.GET_TRAILER_API_SUCCESS, payload: { value: response?.callBackStatus } });
            }

        }
    }
    catch (e) {
        alert('Failed to get trailers data');
    }
}


const createTrailerAPI = (value) => {
    let payload = {
        'btId': value.btId.toString(),
        'status': value.status,
        'designationLocation': value.designationLocation,
        'condition': value.condition,
        'purchaseDate': value.purchaseDate,
        'division_id': value.division_id
    };
    return APICallingService.sendRequestForPostWithAuth(url.addTrailr, payload, false, (res) => {
    }, true);
}

function* createTrailerManagement(action) {
    try {
        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(createTrailerAPI, action.payload.value);
        if (response && response?.callBackStatus.toLowerCase() == 'success') {
            alert('Trailer no ' + response.data.id + " Added Successfully")
            yield put({
                type: CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT.GET_RURAL_TRAILER_MANAGEMENT_API_CALL
            })
            yield put({
                type: CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT.ADD_TRAILER_API_SUCCESS, payload: { value: response?.callBackStatus }
            })

        }
        else {
            if (response && response != null && response.Status != 405) {

                alert('Failed to Create trailer');
                yield put({ type: CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT.ADD_TRAILER_API_SUCCESS, payload: { value: response?.callBackStatus } });
            }
        }
    }
    catch (e) {
        alert('Failed to Create trailer');
        yield put({ type: CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT.ADD_TRAILER_API_SUCCESS, payload: { value: 'Failed' } });
    }


}


const editTrailerAPI = (value) => {
    let urlEdit = url.editTrailer + value.id.toString();
    let payload = {
        'btId': value?.btId.toString(),
        'status': value?.status,
        'designationLocation': value?.location,
        'condition': value?.condition,
        'purchaseDate': value?.startDate,
        'division_id': value?.division_id
    };

    return APICallingService.sendRequestForPut(payload, urlEdit, (res) => {
    }, true);

}

function* editTrailerManagement(action) {

    try {
        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(editTrailerAPI, action.payload.value);

        if (response && response != null) {


            alert('Trailer no ' + action.payload.value.id + " Updated Successfully")
            yield put({
                type: CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT.GET_RURAL_TRAILER_MANAGEMENT_API_CALL
            })
            yield put({
                type: CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT.EDIT_TRAILER_API_SUCCESS, payload: { value: response?.callBackStatus }
            })
        }
        else {
            if (response && response != null && response.Status != 405) {

                alert('Failed To Update Trailer');
                yield put({ type: CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT.EDIT_TRAILER_API_SUCCESS, payload: { value: response?.callBackStatus } });
            }
        }
    }
    catch (e) {
        alert('Failed To Update Trailer');
        yield put({ type: CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT.EDIT_TRAILER_API_SUCCESS, payload: { value: 'Failed' } });
    }
}

export { editTrailerManagement, createTrailerManagement, getTrailerManagement };
